// css constants for BottomPanel component
export const primaryBlue400 = "#2d72d2"; // This is mimicking the primary color for blueprint (rather than sds) since that is currently the main blue in the app.
export const baseBorderSecondary = "#c3c3c3";
export const primitiveGray300 = "#ccc";
export const primitiveGray500 = "#767676";
export const semanticTextTertiary = "#959595";
export const smallGraphFontSizePx = 10.5;
export const smallGraphFontSize = `${smallGraphFontSizePx}px`;

// ts constants used in the BottomPanel component
export const TICK_LENGTH = 6;
export const Y_AXIS_ID = `scalebar-yaxis-svg`;
export const Y_AXIS_WIDTH = 41; // Fixed width for y-axis
